
import useActionTranslate from 'FlowBuilder/hooks/useActionTranslate';

export default function CustomContent({ action, onSubmit }) {

  const { fallback: { content, skipButtonText } } = useActionTranslate({ actionId: action.id });

  return (
    <>
      <div className="custom-content" dangerouslySetInnerHTML={{ __html: content }} />
      { action.config.skipButton &&
        <button
          className="button custom-skip-button"
          onClick={() => onSubmit({ skip: true })}
        >
          {skipButtonText}
        </button>
      }
    </>
  )
}
